// this file is autogenerated do no edit directly
export default '1.10.2';
